<div #loader [ngSwitch]="appLoaderType" class="wrapper bgColor8">
	<ng-container *ngSwitchCase="AppLoaderType.default" [ngTemplateOutlet]="defaultLoaderType"></ng-container>
	<ng-container *ngSwitchCase="AppLoaderType.stories" [ngTemplateOutlet]="storiesLoaderType"></ng-container>
</div>

<ng-template #defaultLoaderType>
	<div class="default-loader">
		<div class="title">{{getLoaderTitle()}}</div>
		<ng-container [ngTemplateOutlet]="appLoaderBox"></ng-container>
	</div>
</ng-template>

<ng-template #storiesLoaderType>
	<div class="stories-loader">
		<div class="title">
			<span class="app-title" i18n="Loader Static Message | Part of loader title indicating it is looking for specific categories@@Storiesc6e41a2b57b04c2cb2a71c2bb29838ec"
			>Looking for</span>
			<div class="spin-words">
				<div *ngIf="isUs">
					<span i18n="Loader Category | Text indicating a search category (US context)@@Storiesdacdfdb07a9943999a8663354cd72229">Veterans</span>
					<span i18n="Loader Category | Text indicating a search category (US context)@@Stories314860992178487aa4ea3723ec2f900a">Immigrants</span>
					<span i18n="Loader Category | Text indicating a search category (US context)@@Storiesd4a43e0db2a942ada3b0576399f8f026">Trailblazers</span>
					<span i18n="Loader Category | Text indicating a search category (US context)@@Stories83a5d30cfb254142a13511b36a85d894">Artists</span>
				</div>
				<div *ngIf="!isUs">
					<span i18n="Loader Category | Text indicating a search category (non-US context)@@Stories73467c3c333f42e8a873b19f8033c3b0">surprising</span>
					<span i18n="Loader Category | Text indicating a search category (non-US context)@@Stories3f7b5a580cd24045a760f6a8b53d1097">fascinating</span>
					<span i18n="Loader Category | Text indicating a search category (non-US context)@@Stories85f35fe2ca1c45aaba6db235acb20cf9">personal</span>
				</div>
			</div>
			<br/>
			<span class="app-title" *ngIf="!isUs"
				  i18n="Loader Additional Message | Additional loader message for non-US context@@Stories049c729a2bdd43909d0ad8940068c0d4"
			>discoveries</span>
			<span i18n="Loader Family Search Message | Part of loader message indicating search is in user’s family@@Stories2552352a21e543c2b727ba40a1bba2ef"
			>in your family...</span>
		</div>
		<ng-container [ngTemplateOutlet]="appLoaderBox"></ng-container>
	</div>
</ng-template>

<ng-template #appLoaderBox>
	<div class="spinner">
		<div class="spinner-inner"></div>
		<div class="icon iconAcom"></div>
	</div>
</ng-template>
